module.exports = __webpack_public_path__ + "img/a9_06.74486902.jpg";